export default function About() {
  const about = [
    "10+ Years of Experience",
    "100+ Apps Launched",
    "On-Time Delivery",
    "100% Confidentiality Guaranteed"
  ];
  return (
    <div className="lg:grid sm:grid xl:grid-cols-4 lg:grid-cols-2 sm:grid-cols-2 xl:gap-0 lg:gap-5 gap-5 lg:px-0 px-5">
      {about.map((item, index) => (
        <div key={index}>
          <div className="flex items-center gap-3"          
          data-aos="fade-up"
          data-aos-duration="2500">
            <div>
              <img src="https://glocify.com/images/white-checkbox.svg" alt="circle-check" />
            </div>
            <h4 className="text-base font-normal leading-6 text-white">
              {item}
            </h4>
          </div>
        </div>
      ))}
    </div>
  );
}
